<template>
  <v-card class="funnel-card">
    <div class="d-flex align-center mb-6">
      <img :src="require('@/assets/icons/mar.ia-cor.svg')" alt="mar.ia" style="height: 36px" class="mr-3" />
      <span class="text-h5">Funil de conversão</span>
    </div>
    <mf-funnel-graph
      full-width
      :labels="labels"
      :label-values="labelValues"
      :percentage-values="percentageValues"
      :sub-labels="subLabels"
      :tooltip-revenue="tooltipRevenue"
      :tooltip-percentage="tooltipPercentage"
      :label-revenues="labelRevenues"
      :height="height"
      :width="width"
      :data-set-num="dataSetNum"
      :sub-label-value="subLabelValue"
      :values="funnelChartData"
      :colors="colors"
      :direction="direction"
      :loading="loading"
      :gradient-direction="gradientDirection"
    />
  </v-card>
</template>

<script>
export default {
  name: 'CustomersTypesFunnelGraph',

  props: {
    metrics: {
      type: Object,
      default: () => ({}),
    },
    campaign: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    dateCriteriaFilter: {
      type: Object,
      default: () => ({}),
    },
    channels: {
      type: Array,
      default: () => ['sms', 'email', 'whatsapp', 'push'],
    },
    units: {
      type: Array,
      default: () => [],
    },
    unitsConfiguration: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    labels: [
      'Clientes do segmento',
      'Clientes que compraram no período',
      'Clientes que compraram algum dos produtos da(s) oferta(s)',
      'Clientes que compraram apenas os produtos da(s) oferta(s)',
    ],
    tooltipRevenue: 'Faturamento que esses clientes geraram',
    tooltipPercentage: 'Porcentagem dos clientes do segmento',
    height: 300,
    width: 800,
    dataSetNum: 1,
    subLabelValue: 'percent',
    direction: 'horizontal',
    gradientDirection: 'horizontal',
    colors: [
      ['#09535C', '#09535C'],
      ['#09535C', '#09535C'],
      ['#09535C', '#09535C'],
      ['#09535C', '#09535C'],
    ],
    mock: {
      clients_metrics: {
        general: {
          received: { count: 11565, revenue: 0 },
          received_and_bought: { count: 8512, revenue: 2512583 },
          received_and_bought_with_offer_products: { count: 4251, revenue: 1152583 },
          received_and_bought_with_received_product: { count: 1987, revenue: 712583 },
        },
        channels: {
          sms: {
            received: { count: 3500 },
            received_and_bought: { count: 2600 },
            received_and_bought_with_offer_products: { count: 1300 },
            received_and_bought_with_received_product: { count: 600 },
          },
          email: {
            received: { count: 2800 },
            received_and_bought: { count: 1900 },
            received_and_bought_with_offer_products: { count: 1000 },
            received_and_bought_with_received_product: { count: 500 },
          },
          whatsapp: {
            received: { count: 3400 },
            received_and_bought: { count: 2500 },
            received_and_bought_with_offer_products: { count: 1400 },
            received_and_bought_with_received_product: { count: 650 },
          },
          push: {
            received: { count: 1865 },
            received_and_bought: { count: 1512 },
            received_and_bought_with_offer_products: { count: 551 },
            received_and_bought_with_received_product: { count: 237 },
          },
        },
      },
    },
  }),

  computed: {
    activeChannels() {
      return Array.isArray(this.channels) && this.channels.length > 0 ? this.channels : ['sms', 'email', 'whatsapp', 'push']
    },
    subLabels() {
      const channelToLabel = {
        // sms: 'SMS',
        // email: 'E-mail',
        // whatsapp: 'WhatsApp',
        // push: 'Push do app',
      }
      return this.activeChannels.map((c) => channelToLabel[c]).filter(Boolean)
    },
    baseMetrics() {
      // If proper metrics were provided, prefer them; otherwise, fallback to mocks
      const hasProvidedMetrics = Boolean(this.metrics && this.metrics.clients_metrics)
      return hasProvidedMetrics ? this.metrics : this.mock
    },
    labelValues() {
      return [
        this.baseMetrics?.clients_metrics?.general?.received?.count || 0,
        this.baseMetrics?.clients_metrics?.general?.received_and_bought?.count || 0,
        this.baseMetrics?.clients_metrics?.general?.received_and_bought_with_offer_products?.count || 0,
        this.baseMetrics?.clients_metrics?.general?.received_and_bought_with_received_product?.count || 0,
      ]
    },
    percentageValues() {
      const maxValue = Math.max(...this.labelValues)
      const roundPoint = (number) => Math.round(number * 10) / 10
      return this.labelValues.map((value) => (value === 0 || maxValue === 0 ? 0 : roundPoint((value * 100) / maxValue)))
    },
    labelRevenues() {
      return [
        this.baseMetrics?.clients_metrics?.general?.received?.revenue || 0,
        this.baseMetrics?.clients_metrics?.general?.received_and_bought?.revenue || 0,
        this.baseMetrics?.clients_metrics?.general?.received_and_bought_with_offer_products?.revenue || 0,
        this.baseMetrics?.clients_metrics?.general?.received_and_bought_with_received_product?.revenue || 0,
      ]
    },
    funnelChartData() {
      const c = this.baseMetrics?.clients_metrics?.channels || {}
      const get = (channel, path) => path.reduce((acc, key) => (acc && acc[key] != null ? acc[key] : undefined), c[channel])
      const safe = (value) => (typeof value === 'number' ? value : 0)

      const stages = [
        ['received', 'count'],
        ['received_and_bought', 'count'],
        ['received_and_bought_with_offer_products', 'count'],
        ['received_and_bought_with_received_product', 'count'],
      ]

      return stages.map((path) => this.activeChannels.map((channel) => safe(get(channel, path))))
    },
  },
}
</script>

<style lang="scss" scoped>
.funnel-card {
  padding: 30px 30px 50px 30px;
}
</style>
